import WebViewer from './WebViewer'
export default WebViewer
